import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '.';
import { getHoursMinutes } from '../utils/getHourMinutes';

export interface ISseInitState {
  log: string[],
  isConnected: boolean,
}

const SseSlice = createSlice({
  name: 'SseSlice',
  initialState: {
    log: [],
    isConnected: false,
  } as ISseInitState,

  reducers: {
    setIsConnected: (state: ISseInitState, action: PayloadAction<boolean>) => {
      state.isConnected = action.payload;
    },
    setLogMsg: (state: ISseInitState, action: PayloadAction<string>) => {
      state.log = [
        `${getHoursMinutes()} :: ${action.payload}`,
        ...state.log,
      ];
    },
  },
});

// Reducers
export default SseSlice.reducer;
export const {
  setIsConnected,
  setLogMsg,
} = SseSlice.actions;

// Selectors
export const getIsSseConnected = () => (state: RootState) => state.sseSlice.isConnected;
export const getSseLog = () => (state: RootState) => state.sseSlice.log;
